import React, { useEffect, useState } from 'react';
import { QuestionnaireBlock } from '@coog/react-components';
import PropTypes from 'prop-types';
import { get, isEqual } from 'lodash-es';
import Action from './Action.presentational';

const QuestionnairePresentational = ({
  blockQuestionnaire,
  isFinishedSalesRoute,
  partialUpdateSalesRouteAnswers,
  strings,
  cancelSalesRoute,
  putOnHoldSalesRoute,
  editField,
  willResetForm,
  onResetForm,
  willSaveForm,
  onSaveForm,
  noSaveNotValid,
  i18n,
}) => {
  // questionnaireBlock
  const [isValidQuestionnaireBlock, setIsValidQuestionnaireBlock] = useState(false);
  const [answersQuestionnaireBlock, setAnswersQuestionnaireBlock] = useState();

  // console.log('answersQuestionnaireBlock', answersQuestionnaireBlock);

  const handleChangeIsValidQuestionnaireBlock = isValidLocal => {
    if (isValidLocal !== isValidQuestionnaireBlock) {
      setIsValidQuestionnaireBlock(isValidLocal);
    }
  };

  const handleChangeAnswersQuestionnaireBlock = answersLocal => {
    if (!isEqual(answersLocal, answersQuestionnaireBlock)) {
      setAnswersQuestionnaireBlock(answersLocal);
    }
  };

  const handleEditField = answersLocal => {
    if (answersQuestionnaireBlock && !isEqual(answersLocal, answersQuestionnaireBlock)) {
      editField();
    }
  };

  /**
   * check disable next button
   */
  const checkDisableNextButton = () => {
    let disableNextButton;
    if (isFinishedSalesRoute) {
      disableNextButton = true;
    } else {
      disableNextButton = !isValidQuestionnaireBlock;
    }
    return disableNextButton;
  };

  useEffect(() => {
    if (willSaveForm) {
      if (isValidQuestionnaireBlock) {
        partialUpdateSalesRouteAnswers({ answers: answersQuestionnaireBlock, saveOnly: true })();
        onSaveForm();
      } else {
        noSaveNotValid();
      }
    }
  }, [willSaveForm]);

  // label Button
  const labelNextButton = get(strings, 'editsalesroute.action.button.nextstep.label', 'Etape Suivante');
  const labelCancelButton = get(strings, 'editsalesroute.action.button.cancel.label', 'Annuler');
  const labelPutonholdButton = get(strings, 'editsalesroute.action.button.putonhold.label', 'Mettre en attente');

  return (
    <>
      <QuestionnaireBlock
        questionnaire={blockQuestionnaire}
        eventEmitter={event => {
          handleChangeIsValidQuestionnaireBlock(get(event, 'isValid'));
          handleChangeAnswersQuestionnaireBlock(get(event, 'answers'));
          handleEditField(get(event, 'answers'));
        }}
        strings={strings}
        willResetForm={willResetForm}
        onResetForm={onResetForm}
        i18n={i18n}
      />
      <Action
        isDisabledNextButton={checkDisableNextButton()}
        partialUpdateSalesRoute={partialUpdateSalesRouteAnswers({ answers: answersQuestionnaireBlock })}
        cancelSalesRoute={cancelSalesRoute}
        putOnHoldSalesRoute={putOnHoldSalesRoute}
        labelNextButton={labelNextButton}
        labelCancelButton={labelCancelButton}
        labelPutonholdButton={labelPutonholdButton}
      />
    </>
  );
};

QuestionnairePresentational.propTypes = {
  blockQuestionnaire: PropTypes.object.isRequired, // eslint-disable-line
  isFinishedSalesRoute: PropTypes.bool, // eslint-disable-line
  partialUpdateSalesRouteAnswers: PropTypes.func.isRequired,
  cancelSalesRoute: PropTypes.func.isRequired,
  putOnHoldSalesRoute: PropTypes.func.isRequired,
  strings: PropTypes.objectOf(PropTypes.string),
  editField: PropTypes.func.isRequired,
  willResetForm: PropTypes.bool,
  onResetForm: PropTypes.func,
  willSaveForm: PropTypes.bool,
  onSaveForm: PropTypes.func,
  noSaveNotValid: PropTypes.func,
  i18n: PropTypes.object,
};

QuestionnairePresentational.defaultProps = {
  isFinishedSalesRoute: false,
  strings: {},
  willResetForm: false,
  onResetForm: () => {},
  willSaveForm: false,
  onSaveForm: () => {},
  noSaveNotValid: () => {},
  i18n: {},
};

export default QuestionnairePresentational;
